/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { SectionTabBlock } from './section-tab-block.model';


export class Formdata {
    id: number; // ecf001
    object: string = 'formdata'; // ecf001
    data?: SectionTabBlock[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): Formdata {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; }
        if (data.object != null) {instance.object = data.object; }
        if (data.data != null) {
            instance.data = [];
            ([].concat(data.data)).forEach(occurrence => {
                instance.data.push(new SectionTabBlock().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return Formdata.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: Formdata) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return Formdata.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: Formdata): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
